import { render, staticRenderFns } from "./AnalysisLiteratureDialog.vue?vue&type=template&id=bde9180e&lang=pug&"
import script from "./AnalysisLiteratureDialog.vue?vue&type=script&lang=ts&"
export * from "./AnalysisLiteratureDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports